module.exports = __webpack_public_path__ + "static/media/productos_seguridad.245aa9fd.jpg";